import BaseClass from './system/base'
import createGateConfigurator from './system/gate-configurator'
import FencePriceList from './system/fence-price-list'
import Serializer from './serializerSystem'
import { buildHeightValues, buildWidthValues, nearestAllowedValue, sharedGateHeightValues } from './dimensionLimits'

const System = class {
  constructor (system) {
    this.clone = false
    this.id = system.id
    this.config_id = system.config_id
    this.add_mailbox = system.add_mailbox
    this.add_to_base = system.add_to_base
    this.add_to_config = system.add_to_config
    this.fencePrices = new FencePriceList(system.fence_prices)
    this.base = new BaseClass(system.base, this.fencePrices)
    this.cachedSummary = system.cachedSummary
    this.config_base = system.config_base
    this.config_main = system.config_main
    this.config_sub_1 = system.config_sub_1
    this.config_sub_2 = system.config_sub_2
    this.config_sub_3 = system.config_sub_3
    this.dimension = system.dimension
    this.do_not_add = system.do_not_add
    this.mailbox = system.mailbox
    this.main = createGateConfigurator(system.main)
    this.options = system.options
    this.products = system.products
    this.sub_1 = createGateConfigurator(system.sub_1)
    this.sub_2 = createGateConfigurator(system.sub_2)
    this.sub_3 = createGateConfigurator(system.sub_3)
    this.availableWidth = null
    this.builderSteps = null
    this.montage = 0
    this.base.setFencePriceList(this.fencePrices)
  }

  /**
   * @description initialize start options
  */
  initializeSystem () {
    // set default value to options
    this.options[0].selected = true
    this.updatePfosten()

    const fields = ['base', 'main', 'sub_1', 'sub_2']
    fields.forEach(field => {
      const step = this[field].steps.find(s => s.name === 'Montage')
      const option = step.options.find(o => o.selected)
      if (option && option.selected) {
        option.selected = false
        step.selectedLabel = '--'
      }
    })
    this.setMontageCost()
  }

  setMontageCost () {
    this.calculateAmountProducts()
    const fields = ['base', 'main', 'sub_1', 'sub_2']
    let montageTotal = 0
    fields.forEach(field => {
      const config = 'config_' + field
      if (this[config].show) {
        const montage = Number.parseFloat(this[config].montage) || 0
        const dimensionStep = this[field].steps.find(s => s.type === 'dimension')
        const width = Number.parseFloat(dimensionStep?.width?.value) / 100 || 0
        const quantity = Number.parseFloat(this[field].quantity) || 0
        if (field === 'base') {
          montageTotal += width * quantity * montage
        } else {
          montageTotal += montage
        }
      }
    })
    this.montage = Number.parseFloat(montageTotal.toFixed(2)) || 0
  }

  /**
   * @description update Products
   */
  setProducts () {
    this.calculateAmountProducts()
  }

  /**
   *
   * @param {*} data
   */
  setByConfig (data) {
    this.products.push(data)
  }

  /**
   *
   * @param {*} data
   */
  setConfigShow (data) {
    if (typeof data !== 'undefined') {
      const config = 'config_' + data.config
      this[config].show = (Number.parseInt(data.checked) === 1)

      this.updatePfosten()
    }
  }

  /**
   * Get options
   * @returns {*}
   */
  getOptionsConfig () {
    const stepId = this.config_base.step_p
    const step = this.base.steps.find(s => s.id === stepId)
    if (typeof step !== 'undefined') {
      return {
        stepId: step.id,
        options: step.options
      }
    }
  }

  /**
   *
   * @param {*} data
   */
  setConfigOptionsShow (data) {
    if (typeof data !== 'undefined') {
      const optionId = data.id
      const checked = (Number.parseInt(data.checked) === 1)
      // const column = (Number.parseInt(data.c) === 1)
      const o = this.options.find(o => o.id === optionId)
      o.selected = checked
      /*
      if (column) {
        // if client column
        const checked = false
      } else {
        const checked = true
      }
      */
      this.updatePfosten()
    }
  }

  /**
   * @description update Column
   */
  updatePfosten () {
    this.calculateAmountProducts()
    const fields = ['base', 'main', 'sub_1', 'sub_2']

    fields.forEach(field => {
      const config = 'config_' + field
      const step = this[field].steps.find(s => s.id === this[config].step_p)
      const option = step.options.find(o => o.id === this[config].step_po)
      const oldSelected = step.options.find(o => o.selected)

      if (!this.options[0].selected) {
        const defaultOption = step.options.filter(o => o.id)
        oldSelected.selected = false
        defaultOption[0].selected = true
        step.selectedLabel = defaultOption[0].name
      } else {
        oldSelected.selected = false
        option.selected = true
        // // set new name params
        if (field === 'base' && this.options[0].selected === true) {
          this.base.update()
          const newName = parseFloat((this.availableWidth / 2.50)).toFixed(0) + ' x Stahlpfosten (80 x 80 mm)'
          option.name = newName
        }
      }

      this[field].update()
    })
  }

  /**
   * @param {*} value
   * @description finding this.base step & option and change selected
   */
  setOptionsValue (value) {
    if (!value.stepId) {
      return
    }

    const stepId = value.stepId
    const optionId = value.optionId
    const step = this.base.steps.find(s => s.id === stepId)
    if (!step?.options) {
      return
    }

    const oldSelected = step.options.find(o => o.selected)
    const nowSelected = step.options.find(o => o.id === optionId)
    if (!nowSelected) {
      return
    }

    if (typeof nowSelected.show_for === 'undefined') {
      if (oldSelected) {
        oldSelected.selected = false
      }
      nowSelected.selected = true
      step.options.forEach(o => {
        if (o.selected && typeof o.show_for !== 'undefined') {
          o.selected = false
        }
      })
    } else {
      step.options.forEach(o => {
        if (o.selected && typeof o.show_for !== 'undefined' && o.id !== nowSelected.id) {
          o.selected = false
        }
      })
      nowSelected.selected = true
    }

    step.selectedLabel = nowSelected.name || '--'

    if (this.options?.[0]) {
      this.options[0].selected = String(nowSelected.id) === String(this.config_base.step_po) ||
        /stahlpfosten/i.test(String(nowSelected.name || ''))
    }

    const fields = ['main', 'sub_1', 'sub_2']
    fields.forEach(field => {
      const config = 'config_' + field
      const targetStep = this[field]?.steps?.find(s => s.id === this[config]?.step_p)
      if (!targetStep?.options) {
        return
      }
      const match = this.findMatchingModelOption(targetStep.options, nowSelected.name) ||
        targetStep.options.find(o => String(o.id) === String(nowSelected.id))
      if (match) {
        targetStep.options.forEach(o => {
          o.selected = String(o.id) === String(match.id)
        })
        targetStep.selectedLabel = match.name || '--'
      }
      if (typeof this[field].update === 'function') {
        this[field].update()
      }
    })

    if (typeof this.base.update === 'function') {
      this.base.update()
    }
  }

  /**
   * @param {*} type
   * @param {*} value
   */
  setDimension (type, value, config = 'base') {
    const parsedValue = Number.parseInt(value)
    if (Number.isNaN(parsedValue)) {
      return
    }
    const targetConfig = ['base', 'main', 'sub_1', 'sub_2', 'sub_3'].includes(config) ? config : 'base'
    const dimensionStep = this[targetConfig]?.getDimensionStep?.()

    if (dimensionStep && typeof this[targetConfig].setDimension === 'function') {
      this[targetConfig].setDimension(dimensionStep, type, parsedValue)
    } else if (dimensionStep && dimensionStep[type]) {
      dimensionStep[type].value = parsedValue
      if (typeof this[targetConfig].update === 'function') {
        this[targetConfig].update()
      }
    }

    if (targetConfig === 'base' && this.dimension[type]) {
      this.dimension[type].value = parsedValue
    }

    this.updatePfosten()
    this.calculateAmountProducts()
    if (type === 'width' && targetConfig !== 'base') {
      this.syncSharedHeight()
    }
  }

  /**
   *
   * @param {*} type
   * @param {*} value
   */
  setDimensionBase (type, value) {
    const baseStep = this.base.getDimensionStep()

    if (type === 'height') {
      const height = Number.parseInt(value)
      const fields = ['main', 'sub_1', 'sub_2']

      fields.forEach(field => {
        const step = this[field].getDimensionStep()

        if (step) {
          this[field].setDimension(step, 'height', height)
        }
      })
      this.dimension.height.value = height

      if (baseStep) {
        this.base.setDimension(baseStep, 'height', height)
      }
    } else if (type === 'width') {
      this.dimension.width.value = Number.parseInt(value)
      this.updatePfosten()
    }

    this.calculateAmountProducts()
  }

  /**
    * @description set quantity for option
    * @param item - object
    **/
  setQuantity (item) {
    let count = 0
    const step = this.main.steps.find(s => s.id === this.config_main.steps[0])
    const option = step.options.find(o => o.id === item.id)
    if (option.value === 0) {
      option.selected = true
    }
    if (item.action === '+') {
      count = Math.min(option.value + 1, option.max)
      option.value = count
    } else if (item.action === '-') {
      count = Math.max(option.value - 1, option.min)
      option.value = count
      if (count === 0) {
        option.selected = false
      }
    }
    // step.labelSelected = step.labelSelected
    this.main.calculateTotalPrice({ step: step.id, option: item.id })
    this.main.update()
  }

  /**
    * @param item - object
    * @description - set quantity for flugeltore
    */
  setSubTwoQuantity (item) {
    let count = 0
    const step = this.sub_2.steps.find(s => s.id === this.config_sub_2.steps[0])
    const option = step.options.find(o => o.id === item.id)

    if (option.value === 0) {
      option.selected = true
    }
    if (item.action === '+') {
      count = Math.min(option.value + 1, option.max)
      option.value = count
    } else if (item.action === '-') {
      count = Math.max(option.value - 1, option.min)
      option.value = count
      if (count === 0) {
        option.selected = false
      }
    }
    // step.labelSelected = step.labelSelected
    this.sub_2.calculateTotalPrice({ step: step.id, option: item.id })
    this.sub_2.update()
  }

  /**
   *
   * @param {*} value
   */
  setMainOptions (value) {
    if (!value || !value.id) {
      return
    }

    if (value.attr === 'parent' || value.attr === 'child') {
      const steps = this.config_main.steps || []
      steps.forEach(stepId => {
        const item = this.main.steps.find(s => s.id === stepId)
        if (!item || !item.options) {
          return
        }

        if (value.attr === 'parent') {
          const parentIsChecked = item.options.find(o => o.selected && o.disabled === false)
          const nowIsChecked = item.options.find(o => o.id === value.id)
          if (!nowIsChecked) {
            return
          }

          if (parentIsChecked && parentIsChecked.selected) {
            parentIsChecked.selected = false
            nowIsChecked.selected = !!value.checked
          } else {
            if (parentIsChecked) {
              parentIsChecked.selected = true
            }
            nowIsChecked.selected = false
          }
        } else {
          const nowIsChecked = item.options.find(o => o.id === value.id)
          if (nowIsChecked) {
            nowIsChecked.selected = !!value.checked
          }
        }
      })
    } else {
      const step = this.main.steps.find(s => s.id === value.attr)
      if (!step || !step.options) {
        return
      }

      const option = step.options.find(o => o.id === value.id)
      if (!option) {
        return
      }

      if (option.type === 'check') {
        option.selected = !!value.checked
      } else {
        step.options.forEach(o => {
          if (o.selected && o.id !== option.id && o.type !== 'check') {
            o.selected = false
          }
        })
        option.selected = true
      }
    }

    this.main.update()
  }

  /**
   * @class this.sub_1
   * @param {*} value
   */
  setSubOneOption (value) {
    const step = this.sub_1.steps.find(s => s.id === value.attr)
    const option = step.options.find(o => o.id === value.id)

    if (option.type === 'check') {
      option.selected = value.checked
    } else {
      const oldOption = step.options.find(o => o.selected)
      if (oldOption && oldOption.selected) {
        oldOption.selected = false
        option.selected = true
      } else {
        option.selected = true
      }
    }
    this.sub_1.update()
  }

  /**
   * @class this.sub_2
   * @param {*} value
   */
  setSubTwoOption (value) {
    console.log(value)
    const step = this.sub_2.steps.find(s => s.id === value.attr)
    const option = step.options.find(o => o.id === value.id)

    if (option.type === 'check') {
      option.selected = value.checked
    } else {
      const oldOption = step.options.find(o => o.selected)
      if (oldOption && oldOption.selected) {
        oldOption.selected = false
        option.selected = true
      } else {
        option.selected = true
      }

      // this.sub_2.selectOption({id: value.attr}, {id: value.id});
    }
    this.sub_2.update()
  }

  /**
   * @class this.sub_3
   * @param {*} value
   */
  setSubThreeOption (value) {
    const step = this.sub_3.steps.find(s => s.id === value.attr)
    const option = step.options.find(o => o.id === value.id)

    if (value.name === 'children') {
      option.selected = true
    } else {
      step.options.filter(o => { o.selected = false })
      option.selected = true
    }
    const baseStep = this.base.steps.find(s => s.name.toLowerCase() === 'briefkasten')
    // optionBase = baseStep.options.find(o => o.selected);

    this.sub_3.update()
    if (baseStep) {
      baseStep.selectedLabel = step.selectedLabel
      /* optionBase.selected = false;
      let newBaseOption = baseStep.options.find(o => o.name === option.name);
      if (newBaseOption) {
        newBaseOption.selected = true;
      }
      console.log(newBaseOption);
      console.log(optionBase); */
      // this.base.update();
    }
  }

  /**
   *
   * @param {true/false} data
   */
  setMontageToBase (data) {
    const fields = ['base', 'main', 'sub_1', 'sub_2']
    fields.forEach(field => {
      const step = this[field].steps.find(s => s.name === 'Montage')
      if (data) {
        step.selectedLabel = 'Mit Komplettmontage'
      } else {
        step.selectedLabel = '--'
      }
    })
  }

  /**
   * @description preview image on the front page live preview
   */
  getPreviewImages () {
    const fields = ['main', 'base', 'sub_1', 'sub_2'] // without sub_2
    const array = []
    fields.forEach(field => {
      const imgs = this[field].getPreviewImages()
      array.push({ config: field, images: imgs })
    })
    return array
  }

  /**
   * @description magik function to set up navigation menu
   */
  getStepMenu () {
    const configFields = ['step_main', 'step_sub']
    const steps = []
    let i = 0
    configFields.forEach(configField => {
      const step = this.base.steps.find(step => step.id === this.config_base[configField])
      if (step.name === 'Form') {
        steps.push(
          {
            id: step.id,
            name: step.name,
            sort: 3,
            type: step.type
          }
        )
      } else {
        steps.push(
          {
            id: step.id,
            name: step.name,
            type: step.type,
            sort: i
          }
        )
      }

      i++
    })
    // set farbe & dimensilon steps
    const color = this.base.steps.find(step => step.type === 'color')
    steps.push(
      {
        id: color.id,
        name: color.name,
        sort: 4,
        type: color.type
      },
      {
        id: 'masse-id',
        name: 'Maße',
        type: 'dimension',
        sort: 2
      }
    )
    const fields = ['main', 'sub_1', 'sub_2', 'sub_3']
    fields.forEach(field => {
      const step = this[field]
      const config = 'config_' + field
      steps.push({
        id: step.id,
        name: step.name,
        type: 'steps_items',
        show: this[config].show,
        config: field,
        image: this[config].image || null
      })
    })
    // set options (Pfosten)
    if (this.options?.length) {
      steps.push({
        id: this.options[0].id,
        name: 'Pfosten',
        type: 'options',
        config: 'opt',
        sort: steps.length
      })
    }
    steps.push({
      id: 'zusammenfssung',
      name: 'Zusammenfassung',
      type: 'total',
      config: 'total'
    })
    return steps
  }

  /**
   * @description set steps
   */
  getSteps () {
    const configFields = ['step_main', 'step_sub']
    const steps = []
    configFields.forEach(configField => {
      const step = this.base.steps.find(step => step.id === this.config_base[configField])
      steps.push(step)
    })
    // set farbe & dimensilon steps
    const color = this.base.steps.find(step => step.type === 'color')
    const masseWidth = this.dimension?.width
    const masseHeight = this.dimension?.height
    const masseLabel = (masseWidth && masseHeight)
      ? `${masseWidth.value}${masseWidth.unit} x ${masseHeight.value}${masseHeight.unit}`
      : '--'

    steps.push(
      color,
      {
        id: 'masse-id',
        name: 'Maße',
        title: this.dimension?.title || '',
        visible: true,
        type: 'dimension',
        price: 0,
        height: this.dimension.height,
        width: this.dimension.width,
        selectedLabel: masseLabel
      }
    )
    const fields = ['main', 'sub_1', 'sub_2', 'sub_3']
    fields.forEach(field => {
      const step = this[field]
      const config = 'config_' + field
      const isShown = !!this[config]?.show
      steps.push({
        id: step.id,
        name: step.name,
        visible: true,
        type: 'steps_items',
        price: step.price,
        options: step.steps,
        show: isShown,
        config: field,
        image: this[config]?.image || null,
        selectedLabel: isShown ? this.getConfigSelectedLabel(field) : '--'
      })
    })
    // set options (Pfosten)
    if (this.options?.length) {
      const pfostenStep = this.base.steps.find(step => step.id === this.config_base.step_p)
      const selectedPfosten = pfostenStep?.options?.find(option => option.selected)
      steps.push({
        id: this.options[0].id,
        name: 'Pfosten',
        visible: true,
        type: 'options',
        options: null,
        show: true,
        selectedLabel: selectedPfosten?.name || '--'
      })
    }
    steps.push({
      id: 'zusammenfssung',
      name: 'Zusammenfassung',
      visible: true,
      type: 'total',
      options: null,
      config: 'total',
      selectedLabel: '--'
    })

    return steps
  }

  getConfigSelectedLabel (field) {
    const configurator = this[field]
    if (!configurator) {
      return '--'
    }

    if (field === 'sub_3') {
      const selected = (configurator.steps || [])
        .filter(step => !step.model_step && step.type !== 'dimension')
        .flatMap(step => (step.options || []).filter(option => option.selected && !option.disabled))
        .map(option => option.name)
        .filter(Boolean)

      if (selected.length) {
        return selected.join(', ')
      }

      const stepLabel = (configurator.steps || [])
        .map(step => step.selectedLabel)
        .find(label => label && label !== '--')

      return stepLabel || '--'
    }

    const dimensionStep = typeof configurator.getDimensionStep === 'function'
      ? configurator.getDimensionStep()
      : configurator.steps?.find(step => step.type === 'dimension')

    if (dimensionStep?.width && dimensionStep?.height) {
      return `${dimensionStep.width.value}${dimensionStep.width.unit} x ${dimensionStep.height.value}${dimensionStep.height.unit}`
    }

    if (dimensionStep?.selectedLabel && dimensionStep.selectedLabel !== '--') {
      return String(dimensionStep.selectedLabel)
        .replace(/AW\.?\d+(?:\.\d+)*\s*(?:\([^)]*\))?\s*,?\s*/gi, '')
        .trim() || '--'
    }

    return '--'
  }

  /**
   * @description get data from main config
   */
  getFromMainConfig () {
    const stepsId = this.config_main.steps
    const data = []
    stepsId.forEach(s => {
      data.push(this.main.steps.find(step => step.id === s))
    })
    console.log(data)
    return data
  }

  /**
   * @description get data from sub_1 config
   */
  getFromSub1Config () {
    const stepsId = this.config_sub_1.steps
    const data = []
    stepsId.forEach(s => {
      data.push(this.sub_1.steps.find(step => step.id === s))
    })
    return data
  }

  /**
   * @description get data from sub_2 config
   */
  getFromSub2Config () {
    const stepsId = this.config_sub_2.steps
    const data = []
    stepsId.forEach(s => {
      data.push(this.sub_2.steps.find(step => step.id === s))
    })
    return data
  }

  /**
   * @description get data from base config
   */
  getBaseSubSteps () {
    const steps = this.config_base.steps
    const data = []
    steps.forEach(step => {
      const item = this.base.steps.find(s => s.id === step)

      data.push(item)
    })
    return data
  }

  /**
   * @description get data from sub_3 config
   */
  getFromSub3Config () {
    const stepsId = this.config_sub_3.steps
    const hiddenOptionNames = ['links', 'rechts']

    return stepsId
      .map(s => this.sub_3.steps.find(step => step.id === s))
      .filter(Boolean)
      .map(step => {
        const options = (step.options || []).filter(option => {
          const name = String(option.name || '').toLowerCase().trim()
          if (hiddenOptionNames.includes(name)) {
            if (option.selected) {
              option.selected = false
            }
            return false
          }
          return true
        })
        return {
          ...step,
          options
        }
      })
      .filter(step => Array.isArray(step.options) && step.options.length > 0)
  }

  /**
   * @description calculation and return total price
   * @returns total
   */
  getTotalPrices () {
    const basePrice = Math.round(this.base.price.discounted)
    const mainPrice = (this.config_main.show === true) ? this.main.price.discounted : 0
    const sub1 = (this.config_sub_1.show === true) ? this.sub_1.price.discounted : 0
    const sub2 = (this.config_sub_2.show === true) ? this.sub_2.price.discounted : 0
    const sub3 = (this.config_sub_3.show === true) ? this.sub_3.price.discounted : 0

    const discountedPrice = Math.round(basePrice + mainPrice + sub1 + sub2 + sub3)

    const baseOldPrice = Math.round(this.base.price.old_price)
    const mainOldPrice = (this.config_main.show === true) ? this.main.price.old_price : 0
    const subOld1 = (this.config_sub_1.show === true) ? this.sub_1.price.old_price : 0
    const subOld2 = (this.config_sub_2.show === true) ? this.sub_2.price.old_price : 0
    const subOld3 = (this.config_sub_3.show === true) ? this.sub_3.price.old_price : 0

    const oldPrice = Math.round(baseOldPrice + mainOldPrice + subOld1 + subOld2 + subOld3)

    return {
      discounted: discountedPrice,
      price: oldPrice
    }
  }

  /**
   * @description I do not what is it function
   */
  getMailboxName () {
    const step = this.sub_3.steps.find(s => s.id === this.config_sub_3.step_main)
    const option = step.options.find(o => o.selected)
    return option.name
  }

  getMetersFromConfigs () {
    const fields = ['main', 'sub_1', 'sub_2']
    const data = []

    fields.forEach(field => {
      const dim = this[field].getDimensionStep().width.value
      const cm = dim / 100

      data.push({ name: field, value: cm })
    })
    return data
  }

  normalizeModelName (name) {
    return String(name || '')
      .toLowerCase()
      .replace(/\s+/g, '')
  }

  getModelCode (name) {
    const match = String(name || '').match(/aw\.?\d+(?:\.\d+)*/i)
    return match ? match[0].toLowerCase().replace(/\./g, '') : null
  }

  getModelSuffix (name) {
    const match = String(name || '').match(/\(([^)]+)\)/)
    return match ? match[1].toLowerCase().trim() : null
  }

  findMatchingModelOption (options, selectedName) {
    if (!options?.length || !selectedName) {
      return null
    }

    const serializer = new Serializer()
    const selectedNorm = this.normalizeModelName(selectedName)
    const selectedSlug = serializer.slugify(selectedNorm)

    let match = options.find(option => this.normalizeModelName(option.name) === selectedNorm)
    if (match) {
      return match
    }

    match = options.find(option => {
      return serializer.slugify(this.normalizeModelName(option.name)) === selectedSlug
    })
    if (match) {
      return match
    }

    const selectedCode = this.getModelCode(selectedName)
    if (!selectedCode) {
      return null
    }

    const candidates = options.filter(option => this.getModelCode(option.name) === selectedCode)
    if (candidates.length === 1) {
      return candidates[0]
    }

    const selectedSuffix = this.getModelSuffix(selectedName)
    if (selectedSuffix) {
      const bySuffix = candidates.find(option => {
        return this.getModelSuffix(option.name) === selectedSuffix
      })
      if (bySuffix) {
        return bySuffix
      }
    }

    return candidates[0] || null
  }

  // set selected optins for all config
  selectOptionAll (option) {
    const fields = ['main', 'base', 'sub_1', 'sub_2']
    const configFields = ['step_main', 'step_sub']

    configFields.forEach(configField => {
      let mainStepOptionName
      const step = this.base.steps.find(step => step.id === this.config_base[configField])
      if (step && (mainStepOptionName = step.options.find(o => o.id === option.id))) {
        fields.forEach(field => {
          const configStr = 'config_' + field
          const stepId = this[configStr]?.[configField]
          if (!stepId) {
            return
          }
          const targetStep = this[field]?.steps?.find(s => s.id === stepId)
          if (!targetStep?.options) {
            return
          }
          const matchingOption = this.findMatchingModelOption(targetStep.options, mainStepOptionName.name)
          if (matchingOption) {
            this[field].selectOption({ id: targetStep.id }, { id: matchingOption.id })
          }
        })
      }
    })

    const selectedBaseOption = this.base.steps
      .find(step => step.model_step)
      ?.options
      ?.find(item => item.id === option.id) || option

    fields.forEach(field => {
      const modelStep = this[field]?.steps?.find(step => step.model_step)
      if (!modelStep?.options) {
        return
      }
      const matchingOption = this.findMatchingModelOption(modelStep.options, selectedBaseOption.name)
      if (matchingOption) {
        this[field].selectOption({ id: modelStep.id }, { id: matchingOption.id })
        this.clampConfiguratorDimension(this[field])
        if (typeof this[field].update === 'function') {
          this[field].update()
        }
      }
    })
    this.syncSharedHeight()
    this.calculateAmountProducts()
  }

  visibleGateConfigurators () {
    return ['main', 'sub_1', 'sub_2']
      .filter(field => this['config_' + field]?.show && this[field])
      .map(field => this[field])
  }

  clampConfiguratorDimension (configurator) {
    const dimensionStep = typeof configurator.getDimensionStep === 'function'
      ? configurator.getDimensionStep()
      : null
    if (!dimensionStep || typeof configurator.setDimension !== 'function') {
      return
    }
    const width = buildWidthValues(configurator)
    const nextWidth = nearestAllowedValue(width.values, dimensionStep.width?.value)
    if (width.values.length && nextWidth !== Number.parseInt(dimensionStep.width?.value, 10)) {
      configurator.setDimension(dimensionStep, 'width', nextWidth)
    }
    const heights = buildHeightValues(configurator)
    const nextHeight = nearestAllowedValue(heights, dimensionStep.height?.value)
    if (heights.length && nextHeight !== Number.parseInt(dimensionStep.height?.value, 10)) {
      configurator.setDimension(dimensionStep, 'height', nextHeight)
    }
  }

  syncSharedHeight () {
    if (this.syncingSharedHeight || !this.dimension?.height) {
      return
    }
    const allowed = sharedGateHeightValues(this.visibleGateConfigurators())
    if (!allowed.length) {
      return
    }
    const next = nearestAllowedValue(allowed, this.dimension.height.value)
    if (next === Number.parseInt(this.dimension.height.value, 10)) {
      return
    }
    this.syncingSharedHeight = true
    this.setDimensionBase('height', next)
    this.syncingSharedHeight = false
  }

  // set color for all selected options
  selectColorAll (option) {
    const fields = ['base', 'main', 'sub_1', 'sub_2']
    const serializer = new Serializer()

    fields.forEach(field => {
      const step = this[field].steps.find(step => step.type === 'color')
      const stepBase = this.base.steps.find(step => step.type === 'color') // get base step
      const baseStepOptionName = stepBase.colors.find(c => c.id === option.id)
      const matchingOption = step.colors.filter(c => {
        return serializer.slugify(c.name.replace(/ +/g, '')) === serializer.slugify(baseStepOptionName.name.replace(/ +/g, ''))
      })
      const selectedOption = step.colors.find(c => c.selected)
      if (matchingOption.length === 1 && selectedOption.id !== matchingOption[0].id) {
        this[field].selectColor({ id: step.id }, { id: matchingOption[0].id })
      }
    })
  }

  /**
   * @description calculation and set to @array products
   */
  calculateAmountProducts () {
    let availableWidth = this.dimension.width.value * this.dimension.width.factor
    const baseDimensionStep = this.base.getDimensionStep()
    if (baseDimensionStep?.height && this.dimension?.height && this.dimension.height.unit === baseDimensionStep.height.unit) {
      baseDimensionStep.height.value = Number.parseInt(this.dimension.height.value, 10)
    }
    const baseDim = baseDimensionStep.width
    const addToConfig = !this.do_not_add ? this.add_to_config : 0
    const addToBase = !this.do_not_add ? this.add_to_base : 0
    const fields = ['main', 'sub_1', 'sub_2']

    let data = {}
    let fenceMeters = 0
    this.products = []
    fields.forEach(field => {
      const config = 'config_' + field
      if (this[config].show) {
        data = {
          config_id: this[field].id,
          amount: 1,
          config: field,
          // availableWidth: availableWidth / 100,
          dimension: this[field].getDimensionStep(),
          price: this[field].price,
          name: this[field].name,
          steps: this[field].getActiveSteps()
        }

        this.setByConfig(data)
        availableWidth -= this[field].getDimensionStep().width.value - addToConfig
        this.availableWidth = availableWidth / 100
      }
    })

    // remaining base
    if (baseDim.min <= availableWidth) {
      let timesBase; let rest
      let baseWidth = baseDim.max
      let minRest = availableWidth
      let minTimes = availableWidth
      let minWidth = baseWidth

      do {
        timesBase = Math.floor(availableWidth / (baseWidth + addToBase))
        rest = availableWidth - timesBase * (baseWidth + addToBase)

        if (rest <= minRest) {
          minRest = rest
          minTimes = timesBase
          minWidth = baseWidth
        }
        if (rest > 0) {
          baseWidth -= baseDim.step
        }
      } while (rest > 0 && baseWidth > baseDim.min)
      // (20m * 100) - 350 =
      /* let s = availableWidth / 100;
      let m = s.toFixed(2);
            console.log(this.round10(m, 1)); */
      this.base.getDimensionStep().width.value = minWidth
      this.availableWidth = availableWidth / 100
      fenceMeters = this.availableWidth

      const q = this.base.steps.find(step => step.type === 'quantity')
      q.value = minTimes
      q.aw = this.availableWidth
      data = {
        amount: 1,
        config: 'base',
        config_id: this.base.id,
        dimension: this.base.getDimensionStep(),
        availableWidth: this.availableWidth,
        price: this.base.price,
        name: this.base.name,
        steps: this.base.steps
      }

      this.setByConfig(data)
    }
    this.base.setRunningMeters(fenceMeters)
    this.base.update()
  }

  /* round10 (num, dp) {
    var numToFixedDp = Number(num).toFixed(dp);
    return Number(numToFixedDp);
  } */

  /**
   * @description summary
   */
  summary () {
    const summary = {
      dimension: JSON.stringify(this.dimension),
      products: [],
      montage: this.montage
    }

    const normalizeImages = (images) => {
      return (Array.isArray(images) ? images : []).map((image, index) => ({
        path: image.path,
        order: typeof image.order === 'number' ? image.order : index,
        option_id: image.option_id || null,
        step_id: image.step_id || null
      })).filter(image => !!image.path)
    }

    this.products.filter(product => {
      return product.amount > 0
    }).forEach(product => {
      const previewImages = this[product.config].getPreviewImages()
      const img = normalizeImages(previewImages)

      if (this.add_mailbox && this[product.config].config_id === this.base.config_id) {
        const quantityStep = this.base.steps.find(step => step.type === 'quantity')
        const step = this.base.steps.find(step => step.id === this.mailbox.step)
        const mailboxOption = step.options.find(option => option.id === this.mailbox.option)
        const selectedBeforeMailboxOption = step.options.find(option => option.selected)
        quantityStep.value = 1
        selectedBeforeMailboxOption.selected = false
        mailboxOption.selected = true
        step.selectedLabel = mailboxOption.name
        if (quantityStep.value > 1) {
          quantityStep.value = quantityStep.value - 1
          summary.products.push({
            amount: 1,
            config: product.config,
            summary: {
              id: this[product.config].id,
              images: img,
              name: this[product.config].name,
              price: {
                discounted: this[product.config].price.discounted,
                total: this[product.config].price.old_price
              },
              steps: this[product.config].getActiveSteps().filter(s => s.visible).map(step => {
                return {
                  name: step.name,
                  printDescription: step.printDescription,
                  value: step.selectedLabel,
                  price: Number(step.price?.total || 0)
                }
              })
            }
          })
        }

        summary.products.push({
          amount: 1,
          config: product.config,
          summary: {
            id: this[product.config].id,
            images: img,
            name: this[product.config].name,
            price: {
              discounted: this[product.config].price.discounted,
              total: this[product.config].price.old_price
            },
            steps: this[product.config].getActiveSteps().filter(s => s.visible).map(step => {
              return {
                name: step.name,
                printDescription: step.printDescription,
                value: step.selectedLabel,
                price: Number(step.price?.total || 0)
              }
            })
          }
        })
      } else {
        summary.products.push({
          amount: product.amount,
          config: product.config,
          summary: {
            id: this[product.config].id,
            images: img,
            name: this[product.config].name,
            price: {
              discounted: this[product.config].price.discounted,
              total: this[product.config].price.old_price
            },
            steps: this[product.config].getActiveSteps().filter(s => s.visible).map(step => {
              if (product.config === 'base') {
                return {
                  name: step.name,
                  printDescription: step.printDescription,
                  value: (step.name === 'Maße') ? '-' : step.selectedLabel,
                  price: (step.name === 'Maße') ? 0 : Number(step.price?.total || 0)
                }
              } else {
                return {
                  name: step.name,
                  printDescription: step.printDescription,
                  value: step.selectedLabel,
                  price: Number(step.price?.total || 0)
                }
              }
            })
          }
        })
      }
    })

    return summary
  }
}
export default System
